import { render, staticRenderFns } from "./ChannelStatusItem.vue?vue&type=template&id=958be31a&scoped=true"
import script from "./ChannelStatusItem.vue?vue&type=script&lang=js"
export * from "./ChannelStatusItem.vue?vue&type=script&lang=js"
import style0 from "./ChannelStatusItem.vue?vue&type=style&index=0&id=958be31a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958be31a",
  null
  
)

export default component.exports